<template>
    <BaseModal name="superSuppliersModal" width="1280" @before-close="" @before-open="loadData" :clickToClose="false"
        :shiftY="0.5" :adaptive="false" height="auto" :scrollable="true" classes="bg-system-main-block shadow-none d-flex flex-column">
        <!-- ШАПКА  -->
        <BaseLoader v-if="localLoading"></BaseLoader>
        <div class="d-flex justify-content-between px-30 align-items-center bg-system-secondary gap-30"
            style="padding-block: 11px;">
            <div class="d-flex text-dark justify-content-between flex-grow-1 fsc-12">
                <div class="fsc-12">Заявка
                    <span class="fw-medium">№{{ dataForModal?.b2b_orders__id }}</span>
                    от
                    <span class="fw-medium">
                        {{ $time(
                            dataForModal?.b2b_orders__created_at
                        ).format(`${userSetting.company__tempalte_date}
                        HH:mm`) }} UTC
                    </span>
                </div>
                <div class="fsc-12">Статус:
                    <span class="fw-bolder">{{ dataForModal?.b2b_orders__status_name }}</span>
                </div>
            </div>
            <button type="button" class="btn-close p-0 flex-shrink-0 fsc-18"
                @click="$modal.hide('superSuppliersModal')"></button>
        </div>
        <!-- КОНТЕНТ -->
        <div v-show="!localLoading" class=" d-flex gap-10 flex-grow-1 pt-10"
            style=" padding-left: 27px; padding-right: 27px">
            <div class="system-block h-auto position-relative overflow-auto" style="padding: 8px; width: 520px;">
                <div class="d-flex gap-10 fsc-14 mb-5" style="line-height: 18px;">
                    <div style="width: 117px;">Город</div>
                    <div style="">{{ dataForModal?.cities__name }}</div>
                </div>
                <div class="d-flex gap-10 fsc-14 mb-10" style="line-height: 18px;">
                    <div style="width: 117px;">Наименование</div>
                    <div style="">{{ dataForModal?.b2b_products_description__name }}</div>
                </div>

                <div class="bg-system-secondary border-buted py-5 px-15 mb-5" style="line-height: 18px; height: 30px;">
                    {{ dataForModal?.b2b_orders__buyer_comment }}
                </div>
                <BaseScrollbar style="max-height: 575px; height: 330px;">
                    <div v-html="dataForModal?.b2b_orders__info" class="bg-system-secondary border-buted py-5 px-15 mb-10 "
                        style="min-height: 330px; line-height: 18px">
                        <!-- {{ dataForModal?.b2b_orders__info }} -->
                    </div>
                </BaseScrollbar>
                <div class="mb-10">
                    <div class="fsc-16 fw-semi-bold mb-5" style="line-height: 20px;">Покупатель</div>
                    <div class="d-flex gap-10 fsc-14 mb-5" style="line-height: 18px;">
                        <div style="width: 117px;">ЛС</div>
                        <div style="">{{ dataForModal?.buyer_company_id }}</div>
                    </div>
                    <div class="d-flex gap-10 fsc-14 mb-5" style="line-height: 18px;">
                        <div style="width: 117px;">Сотрудник</div>
                        <div style="">{{ dataForModal?.buyer_employee_name }}</div>
                    </div>
                    <div class="d-flex gap-10 fsc-14 mb-5" style="line-height: 18px;">
                        <div style="width: 117px;">Телефон</div>
                        <div style="">{{ dataForModal?.buyer_employee_phone }}</div>
                    </div>
                    <div class="d-flex gap-10 fsc-14 mb-10" style="line-height: 18px;">
                        <div style="width: 117px;">Почта</div>
                        <div class="d-flex gap-10" style="">{{ dataForModal?.buyer_employee_email }} <svg
                                @click="() => onCopy(dataForModal?.buyer_employee_email)" width="18" height="18"
                                class="cursor-pointer" viewBox="0 0 18 18" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M7.15073 0H16.0891C17.1191 0 17.8768 0.762944 17.8768 1.8V10.8C17.8768 11.8371 17.1191 12.6 16.0891 12.6H12.5138V16.2C12.5138 17.237 11.7561 18 10.7261 18H1.78768C0.757723 18 0 17.237 0 16.2V7.19998C0 6.16293 0.757723 5.39998 1.78768 5.39998H5.36305V1.8C5.36305 0.762944 6.12077 0 7.15073 0ZM5.36305 7.19998H1.78768V16.2H10.7261V12.6H7.15073C6.12077 12.6 5.36305 11.8371 5.36305 10.8V7.19998ZM7.15074 1.80001V10.8H16.0892V1.80001H7.15074Z"
                                    fill="#666666" />
                            </svg>
                        </div>
                    </div>
                </div>


                <div class="">
                    <div class=" mb-5 d-flex gap-10">
                        <div class="fsc-16 fw-semi-bold" style="width: 117px; line-height: 20px;">Поставщик</div>
                        <BaseSelect style="width: 377px" placeholder="" :showNoOptions="false" :showNoResults="false"
                            @search-change="suppliersSearch = $event"
                            :disabled="isArchive" selectLabel="" deselectLabel="" @input="
                                ({ value }) => {
                                    updateValue({ name: 'b2b_orders__supplier_company_id', value: value });
                                    saveModal(false);

                                }
                            "
                            v-model="selectValues.b2b_orders__supplier_company_id" label="label"
                            :options="suppliersSearchOptions">
                        </BaseSelect>
                    </div>
                    <div class="d-flex gap-10 fsc-14 mb-5" style="line-height: 18px;">
                        <div style="width: 117px;">Админ</div>
                        <div style="">{{ dataForModal?.supplier_employee_name }}</div>
                    </div>
                    <div class="d-flex gap-10 fsc-14 mb-5" style="line-height: 18px;">
                        <div style="width: 117px;">Телефон</div>
                        <div style="">{{ dataForModal?.supplier_employee_phone }}</div>
                    </div>
                    <div class="d-flex gap-10 fsc-14 mb-5" style="line-height: 18px;">
                        <div style="width: 117px;">Почта</div>
                        <div class="d-flex gap-10" style="">{{ dataForModal?.supplier_employee_email }} <svg
                                @click="() => onCopy(dataForModal?.supplier_employee_email)" width="18" height="18"
                                class="cursor-pointer" viewBox="0 0 18 18" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M7.15073 0H16.0891C17.1191 0 17.8768 0.762944 17.8768 1.8V10.8C17.8768 11.8371 17.1191 12.6 16.0891 12.6H12.5138V16.2C12.5138 17.237 11.7561 18 10.7261 18H1.78768C0.757723 18 0 17.237 0 16.2V7.19998C0 6.16293 0.757723 5.39998 1.78768 5.39998H5.36305V1.8C5.36305 0.762944 6.12077 0 7.15073 0ZM5.36305 7.19998H1.78768V16.2H10.7261V12.6H7.15073C6.12077 12.6 5.36305 11.8371 5.36305 10.8V7.19998ZM7.15074 1.80001V10.8H16.0892V1.80001H7.15074Z"
                                    fill="#666666" />
                            </svg>
                        </div>
                    </div>
                    <div class="d-flex gap-15">
                        <div @click="sendOrder('supplier')"
                            class="base-button base-button--action fsc-14  text-uppercase wp-50"
                            style="line-height: 18px; padding-block: 1.5px; padding-inline: 1px; letter-spacing: -1px;">
                            Отправить заявку поставщику<br />(e-mail+SMS)
                        </div>
                        <div @click="sendOrder('partner')"
                            class="base-button base-button--action fsc-14  text-uppercase  wp-50"
                            style="line-height: 18px; padding-block: 1.5px; padding-inline: 1px; letter-spacing: -1px;">
                            Отправить заявку оф. <br />партнеру (e-mail)
                        </div>
                    </div>
                </div>
            </div>
            <div class="system-block h-auto position-relative bg-white" style="padding: 8px; width: 342px;">
                <div class="fw-semi-bold fsc-16 mb-10">Финансы</div>
                <div class="d-flex flex-column gap-5 mb-10"
                    style="background-color: #86BBF9; border-radius: 5px;padding: 10px;">
                    <div class="d-flex align-items-center gap-5 justify-content-between">
                        <div class="fsc-12">Выручка (оплачена покупателем)</div>
                        <BaseInputNew placeholder="" style="width: 90px" :disabled="isArchive" @input="updateValue"
                            inputClass="text-center" :additionalParams="{}" inputName="b2b_orders__finance_proceeds"
                            :value="dataForModal.b2b_orders__finance_proceeds" nameSign="" />
                    </div>
                    <div class="d-flex align-items-center gap-5 justify-content-between">
                        <div class="fsc-12">Прибыль (если есть данные)</div>
                        <BaseInputNew placeholder="" style="width: 90px" :disabled="isArchive" @input="updateValue"
                            inputClass="text-center" :additionalParams="{}" inputName="b2b_orders__finance_benefit"
                            :value="dataForModal.b2b_orders__finance_benefit" nameSign="" />
                    </div>
                </div>
                <div class="d-flex flex-column gap-5 mb-10"
                    style="background-color: #FA9D8B; border-radius: 5px;padding: 10px;">
                    <div class=" fsc-14 fw-semi-bold">Списать с поставщика ЛС №{{ dataForModal.supplier_company_id }}
                    </div>
                    <div class=" fsc-12">{{ dataForModal.supplier_company_name }}</div>
                    <div class="d-flex align-items-center gap-5 justify-content-between">
                        <div class="fsc-12">Списать %</div>
                        <BaseInputNew placeholder="" style="width: 37px" :disabled="isArchive" @input="updateValue"
                            inputClass="text-center" :additionalParams="{}" inputName="b2b_orders__supplier_percent"
                            :value="dataForModal.b2b_orders__supplier_percent" nameSign="" />
                        <div class="fsc-12">от</div>
                        <BaseSelect style="width: 172px" placeholder="" :showNoOptions="false" :showNoResults="false"
                            :disabled="isArchive" selectLabel="" deselectLabel="" @input="
                                (data) => {
                                    updateValue({ name: 'b2b_orders__supplier_percent_from', value: data.value });
                                }
                            " v-model="selectValues.b2b_orders__supplier_percent_from" label="label"
                            :options="selectOptions.typesSpend">
                        </BaseSelect>
                    </div>
                  </div>

                <div class="d-flex flex-column align-items-center justify-content-center gap-2 py-10 px-5"
                    style="background-color: #BAF1C9; border-radius: 5px;">
                    <div class="fsc-12 fw-semi-bold text-center">
                      Прибыль сервиса
                    </div>
                    <div class="fw-bold text-center" style="font-size: 22px; line-height: 1.1">
                      {{ dataForModal.b2b_orders__supplier_amount }}
                    </div>
                    <div class="fsc-10 text-center text-muted" style="line-height: 1.2">
                      (списывается с баланса поставщика)
                    </div>
                </div>

                <div class="fsc-13 fw-semi-bold text-center mb-5 mt-5">Распределение прибыли сервиса</div>
                <div class="fsc-10 text-center text-muted mb-10" style="line-height: 1.2">
                  (начисляется на баланс участников)
                </div>

                <div class="d-flex flex-column gap-5 mb-10" style="background-color: #BAF1C9; border-radius: 5px;padding: 10px;">
                  <div class="fsc-14 fw-semi-bold">
                    Реферер
                  </div>
                  <div v-if="dataForModal.b2b_orders__referer_company_name" class="fsc-12">
                    {{ dataForModal.b2b_orders__referer_company_name }}
                    <template v-if="dataForModal.b2b_orders__referer_company_id">
                      (ЛС{{ dataForModal.b2b_orders__referer_company_id }})
                    </template>
                  </div>

                  <div class="d-flex flex-column gap-3">
                    <div class="fsc-11">
                      Кф. реф. {{ dataForModal.b2b_orders__referer_koef }}
                    </div>
                    <div class="fsc-11">
                      Доля {{ dataForModal.b2b_orders__referer_base_percent_super }}×{{ dataForModal.b2b_orders__referer_koef }}={{ dataForModal.b2b_orders__referer_percent }}%
                    </div>
                  </div>

                  <div class="d-flex align-items-center gap-5 justify-content-between">
                      <div class="fsc-12">
                        Итого начислить на баланс
                      </div>
                      <BaseInputNew
                        placeholder=""
                        style="width: 90px; opacity: 0.5;"
                        disabled
                        @input="updateValue"
                        inputClass="text-center text-dark bg-transparent"
                        :additionalParams="{}"
                        inputName="b2b_orders__referer_amount"
                        :value="dataForModal.b2b_orders__referer_amount"
                        nameSign=""
                      />
                  </div>
                </div>

                <div class="d-flex flex-column gap-5 mb-10" style="background-color: #BAF1C9; border-radius: 5px;padding: 10px;">
                  <div class="fsc-14 fw-semi-bold">
                    Официальный партнер
                  </div>
                  <div v-if="dataForModal.b2b_orders__partner_company_name" class="fsc-12">
                    {{ dataForModal.b2b_orders__partner_company_name }}
                    <template v-if="dataForModal.b2b_orders__partner_company_id">
                      (ЛС{{ dataForModal.b2b_orders__partner_company_id }})
                    </template>
                  </div>

                  <div class="d-flex flex-column gap-3">
                    <div class="fsc-11">
                      Доля {{ dataForModal.b2b_orders__partner_percent }}%
                    </div>
                  </div>

                  <div class="d-flex align-items-center gap-5 justify-content-between">
                    <div class="fsc-12">Итого начислить на баланс</div>
                    <BaseInputNew
                      placeholder=""
                      style="width: 90px; opacity: 0.5;"
                      disabled
                      @input="updateValue"
                      inputClass="text-center text-dark bg-transparent"
                      :additionalParams="{}"
                      inputName="b2b_orders__partner_amount"
                      :value="dataForModal.b2b_orders__partner_amount"
                      nameSign=""
                    />
                  </div>
                </div>

                <div class="d-flex flex-column gap-5 mb-10" style="background-color: #BAF1C9; border-radius: 5px;padding: 10px;">
                  <div class="fsc-14 fw-semi-bold">
                    Платформа
                  </div>
                  <div v-if="dataForModal.b2b_orders__service_company_name" class="fsc-12">
                    {{ dataForModal.b2b_orders__service_company_name }}
                    <template v-if="dataForModal.b2b_orders__service_company_id">
                      (ЛС{{ dataForModal.b2b_orders__service_company_id }})
                    </template>
                  </div>

                  <div class="d-flex flex-column gap-3">
                    <div class="fsc-11">
                      Доля 100-{{ dataForModal.b2b_orders__referer_percent }}-{{ dataForModal.b2b_orders__partner_percent }}={{ dataForModal.b2b_orders__service_company_percent }}%
                    </div>
                  </div>

                  <div class="d-flex align-items-center gap-5 justify-content-between">
                      <div class="fsc-12">
                        Итого начислить на баланс
                      </div>
                      <BaseInputNew
                        placeholder=""
                        style="width: 90px; opacity: 0.5;"
                        disabled
                        @input="updateValue"
                        inputClass="text-center text-dark bg-transparent"
                        :additionalParams="{}"
                        inputName="b2b_orders__service_amount"
                        :value="dataForModal.b2b_orders__service_amount"
                        nameSign=""
                      />
                  </div>
                </div>
            </div>
            <div class="h-auto" style="width: 344px; height: 682px">
                <div class="system-block h-100 position-relative px-10 pt-5 pb-10">
                    <span class="fsc-11 fw-bold">{{
                        dataLang['vehicles_page__modal__tab_comments__name']
                        }}</span>
                    <div class="d-flex gap-10 mt-15 mb-10">
                        <BaseInputNew placeholder="" width="100%" class="wp-100" input-name="comment"
                            @input="(data) => (newCommentValue = data)" :horizontalTitle="true" ref="commentInput"
                            value="" :additionalParams="{}" name-sign="">
                        </BaseInputNew>
                        <div class="base-button base-button--action px-5 py-5" style="min-height: 26px; height: 26px"
                            @click="sendComment">
                            <img :src="require(`@/assets/icons/add.svg`)" width="12" height="12" />
                        </div>
                    </div>
                    <BaseScrollbar style="max-height: 575px">
                        <div class="comments">
                            <div class="comments-base d-flex flex-column gap-10">
                                <div v-for="(comment, index) of commentsList" :key="comment.id"
                                    class="comment d-flex gap-5 justify-content-between border border-1 border-disabled">
                                    <div class="comment-info d-flex flex-column gap-0">
                                        <p class="comment-info__heading text-black fw-normal fsc-11 lh-sm m-0">
                                            {{
                                                $time(comment.created_at)
                                                    .utc(true)
                                                    .utcOffset(Number(userSetting.company__utc))
                                                    .format(`${userSetting.company__tempalte_date} HH:mm`)
                                            }}
                                            <!-- {{ comment.employees__name }} -->
                                        </p>
                                        <p class="comment-info__content text-black fw-medium fsc-12 lh-sm m-0">
                                            {{ comment.comment }}
                                        </p>
                                    </div>

                                    <div class="comment-actions d-flex h-100">
                                        <div :class="[]"
                                            class="comment-actions__pin d-flex justify-content-center align-items-center rounded-5 cursor-pointer"
                                            @click="
                                                () => {
                                                    fixComment(
                                                        comment.id,
                                                        !comment.is_fixed
                                                    )
                                                    comment.id =
                                                        !comment.is_fixed
                                                }
                                            ">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                viewBox="0 0 16 17" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd" :fill="[
                                                    comment.is_fixed
                                                        ? '#23B14D'
                                                        : 'rgba(49, 48, 61, 1)'
                                                ]"
                                                    d="M10.6749 2.22974L14.2316 5.69537C14.2787 5.74122 14.312 5.7958 14.3316 5.85402L14.5475 6.06994C14.7064 6.22889 14.7064 6.48659 14.5475 6.64554L12.2451 8.94794C12.0861 9.10689 11.8284 9.10689 11.6695 8.94794L11.0939 8.37234C11.0409 8.31936 10.955 8.31936 10.902 8.37234L10.6566 8.61779C10.574 8.70037 10.5535 8.82654 10.6058 8.931L11.3464 10.4124C11.4248 10.5691 11.3941 10.7583 11.2702 10.8822L9.36709 12.7853C9.20814 12.9442 8.95044 12.9442 8.79149 12.7853L6.68096 10.6747L2.41192 14.9438C2.25297 15.1027 1.99527 15.1027 1.83632 14.9438L1.45258 14.56C1.29364 14.4011 1.29364 14.1434 1.45258 13.9844L5.72162 9.71541L3.61109 7.60488C3.45214 7.44593 3.45214 7.18822 3.61109 7.02928L5.51419 5.12617C5.63807 5.0023 5.82731 4.97159 5.98401 5.04993L7.46537 5.79061C7.56983 5.84284 7.696 5.82237 7.77858 5.73978L8.02402 5.49434C8.07701 5.44136 8.07701 5.35546 8.02402 5.30247L7.44842 4.72687C7.28948 4.56793 7.28948 4.31022 7.44842 4.15127L9.75083 1.84887C9.90977 1.68992 10.1675 1.68992 10.3264 1.84887L10.5746 2.09704C10.615 2.13744 10.6484 2.18218 10.6749 2.22974ZM12.9412 6.33209L10.0269 3.49247L9.27116 4.24721C9.16519 4.35317 9.16519 4.52498 9.27116 4.63094L9.84676 5.20654C9.95273 5.31251 9.95273 5.48431 9.84676 5.59027L7.83216 7.60488C7.72619 7.71084 7.55439 7.71084 7.44842 7.60488L6.86777 7.02422C6.84715 7.0036 6.82334 6.98644 6.79725 6.9734L6.16443 6.65699C6.05997 6.60475 5.9338 6.62523 5.85122 6.70781L5.43382 7.12521C5.32786 7.23117 5.32786 7.40298 5.43382 7.50894L8.88743 10.9625C8.99339 11.0685 9.16519 11.0685 9.27116 10.9625L9.68855 10.5452C9.77114 10.4626 9.79161 10.3364 9.73938 10.2319L9.42297 9.59912C9.40993 9.57303 9.39277 9.54922 9.37214 9.5286L8.79149 8.94794C8.68553 8.84198 8.68553 8.67018 8.79149 8.56421L10.8061 6.54961C10.9121 6.44364 11.0839 6.44364 11.1898 6.54961L11.7654 7.12521C11.8714 7.23117 12.0432 7.23117 12.1492 7.12521L12.9412 6.33209Z" />
                                                <path :fill="[
                                                    comment.is_fixed
                                                        ? '#23B14D'
                                                        : 'rgba(49, 48, 61, 1)'
                                                ]"
                                                    d="M12.9412 6.33209L10.0269 3.49247L9.27116 4.24721C9.16519 4.35317 9.16519 4.52498 9.27116 4.63094L9.84676 5.20654C9.95273 5.31251 9.95273 5.48431 9.84676 5.59027L7.83216 7.60488C7.72619 7.71084 7.55439 7.71084 7.44842 7.60488L6.86777 7.02422C6.84715 7.0036 6.82334 6.98644 6.79725 6.9734L6.16443 6.65699C6.05997 6.60475 5.9338 6.62523 5.85122 6.70781L5.43382 7.12521C5.32786 7.23117 5.32786 7.40298 5.43382 7.50894L8.88743 10.9625C8.99339 11.0685 9.16519 11.0685 9.27116 10.9625L9.68855 10.5452C9.77114 10.4626 9.79161 10.3364 9.73938 10.2319L9.42297 9.59912C9.40993 9.57303 9.39277 9.54922 9.37214 9.5286L8.79149 8.94794C8.68553 8.84198 8.68553 8.67018 8.79149 8.56421L10.8061 6.54961C10.9121 6.44364 11.0839 6.44364 11.1898 6.54961L11.7654 7.12521C11.8714 7.23117 12.0432 7.23117 12.1492 7.12521L12.9412 6.33209Z" />
                                            </svg>
                                        </div>
                                        <div class="comment-actions__delete d-flex justify-content-center align-items-center cursor-pointer"
                                            @click="delComment(comment.id)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                viewBox="0 0 16 16" fill="none">
                                                <path
                                                    d="M2.66983 1.70071C2.40222 1.4331 1.96833 1.4331 1.70071 1.70071C1.4331 1.96833 1.4331 2.40222 1.70071 2.66983L7.03088 8L1.70071 13.3302C1.4331 13.5978 1.4331 14.0317 1.70071 14.2993C1.96833 14.5669 2.40222 14.5669 2.66983 14.2993L8 8.96912L13.3301 14.2992C13.5977 14.5668 14.0316 14.5668 14.2992 14.2992C14.5668 14.0316 14.5668 13.5977 14.2992 13.3301L8.96912 8L14.2993 2.66983C14.5669 2.40222 14.5669 1.96833 14.2993 1.70071C14.0317 1.4331 13.5978 1.4331 13.3302 1.70071L8 7.03088L2.66983 1.70071Z"
                                                    fill="black" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </BaseScrollbar>
                </div>
            </div>
        </div>

        <!-- КНОПКИ СОХРАНЕНИЯ -->
        <div class="d-flex align-items-center gap-35" style="padding: 13px 28px 19px 28px">
            <div class="flex-grow-1 d-flex">

            </div>
            <div class="d-flex justify-content-end gap-10">


                <div class="base-button base-button--action fsc-14 px-20 text-uppercase"
                    style="line-height: 19.5px; padding-block: 8px;" @click="$modal.hide('superSuppliersModal')">
                    Отменить
                </div>
                <div class="btn btn-sm btn-primary action-hover fsc-14 px-20 text-uppercase"
                    style="line-height: 19.5px; padding-block: 8px;" @click="saveModal">
                    Сохранить
                </div>
            </div>
        </div>
        <div class="d-flex gap-5" style="position: absolute; bottom: 16px; left: 27px; width: 520px;"
            v-if="dataForModal.b2b_orders__status_id == 1 || dataForModal.b2b_orders__status_id == 2">
            <div @click="$modal.show('orderStartModal')"
                style="cursor: pointer; color: white; font-size: 12px; line-height: 15px; background-color: #23B14D; text-align: center; border-radius: 8px; padding: 6px 10px; flex-grow: 1;">
                Товар выдан/<br />
                услуги оказаны
            </div>
            <div @click="(date) => {
                typeCancelReqest = 6
                $modal.show('lastCancelSupplierModal')
            }"
                style="cursor: pointer;color: white; font-size: 12px; line-height: 15px; background-color: #FF2400; text-align: center; border-radius: 8px; padding: 6px 10px; flex-grow: 1;">
                Отмена поставщиком<br />
                (перенос в архив)
            </div>
            <div @click="(date) => {

                typeCancelReqest = 7
                $modal.show('lastCancelSupplierModal')
            }"
                style="cursor: pointer;color: white; font-size: 12px; line-height: 15px; background-color: #FF2400; text-align: center; border-radius: 8px; padding: 6px 10px; flex-grow: 1;">
                Отмена покупателем<br />
                (перенос в архив)
            </div>
        </div>

        <BaseModal name="lastCancelSupplierModal" width="420" height="320" :clickToClose="false" :shiftY="0.5"
            :adaptive="true" classes="bg-transparent shadow-none">
            <div class="bg-white rounded-25 pt-20 pb-20 px-30 h-100">
                <div class="d-flex justify-content-end">
                    <button type="button" class="btn-close" @click="$modal.hide('lastCancelSupplierModal')"></button>
                </div>
                <div class="d-flex h-100 flex-column justify-content-center pb-10">
                    <p class="text-center fw-semi-bold mb-15">
                        Отмена заявки
                    </p>
                    <p class="text-center mb-0" v-if="typeCancelReqest == 6">
                        Подтвердите отмену поставщиком <br />
                        и перенос заявки в архив
                    </p>

                    <p class="text-center mb-0" v-if="typeCancelReqest == 7">
                        Подтвердите отмену покупателем <br />
                        и перенос заявки в архив
                    </p>

                    <div class="d-flex justify-content-center mt-30 gap-15">

                        <div class="base-button base-button--action fsc-14 px-15 text-uppercase" @click="
                            $modal.hide('lastCancelSupplierModal')
                            ">
                            Отменить
                        </div>
                        <div class="btn btn-sm btn-primary action-hover fsc-14 px-15 text-uppercase" @click="(date) => {
                            updateValue({ name: 'b2b_orders__status_id', value: typeCancelReqest })
                            $modal.hide('lastCancelSupplierModal')
                            saveModal()
                        }">
                            Подтверждаю
                        </div>
                    </div>
                </div>
            </div>
        </BaseModal>

        <div v-if="dataForModal.b2b_orders__status_id == 3 || dataForModal.b2b_orders__status_id == 4"
            class="d-flex gap-5 justify-content-center align-items-center"
            style="position: absolute; bottom: 16px; left: 547px; width: 342px; height: 41px">
            <div style="color: #0C63AA" class="fsc-14" v-if="dataForModal.b2b_orders__status_id == 3">
                Период правок до {{ $time(
                    dataForModal?.b2b_orders__editable_to
                ).format(`${userSetting.company__tempalte_date}`) }} г.
            </div>
            <div v-if="dataForModal.b2b_orders__status_id == 4" @click="(date) => {
                updateValue({ name: 'b2b_orders__status_id', value: 5 })
                saveModal()
            }"
                style="cursor: pointer;color: white; font-size: 14px; line-height: 16px; background-color: #0C63AA; text-align: center; border-radius: 8px; padding: 2.5px ; width: 281px; max-width: 281px; min-width: 281px">
                Провести расчёты <br />
                и перенести заявку в архив
            </div>
        </div>
        <BaseModal name="orderStartModal" width="480" height="370" :clickToClose="false" :shiftY="0.5" :adaptive="true"
            classes="bg-transparent shadow-none">
            <div class="bg-white rounded-25 pt-20 pb-20 px-30 h-100">
                <div class="d-flex justify-content-end">
                    <button type="button" class="btn-close" @click="$modal.hide('orderStartModal')"></button>
                </div>
                <div class="d-flex h-100 flex-column justify-content-center pb-10">
                    <p class="text-center fw-semi-bold mb-15">
                        Товар выдан. Включение периода правок
                    </p>
                    <p class="text-center mb-0">
                        После выдачи товара (оказания услуги) у поставщика есть “Период правок” (время на обмен/возврат
                        товара,
                        согласно ЗЗПП), по завершению которого Сириус имеет право приступить к проверке расчетов и
                        списанию комиссии
                        с поставщика. Выберете дату окончания периода правок.
                    </p>
                    <div class="d-flex mt-30 justify-content-center">
                        <BaseDatePicker v-model="selectedDateForOrder" type="date" placeholder="" class="" lang="ru"
                            style="width: 252px" value-type="format" :clearable="false"
                            :format="`${userSetting.company__tempalte_date}`" @change="(date) => {
                                updateValue({ name: 'b2b_orders__editable_to', value: date.split('.').reverse().join('-') })
                                updateValue({ name: 'b2b_orders__status_id', value: 3 })
                            }">
                        </BaseDatePicker>
                    </div>

                    <div class="d-flex justify-content-center mt-30 gap-15">

                        <div class="base-button base-button--action fsc-14 px-15 text-uppercase" @click="
                            $modal.hide('orderStartModal')
                            ">
                            Отменить
                        </div>
                        <div class="btn btn-sm btn-primary action-hover fsc-14 px-15 text-uppercase" @click="() => {
                            saveModal()
                            selectedDateForOrder = ''
                            $modal.hide('orderStartModal')
                        }">
                            Включить период правок
                        </div>
                    </div>
                </div>
            </div>
        </BaseModal>
    </BaseModal>
</template>

<script>
import GeneralService from "@/api/GeneralService";
import { mapActions, mapState, mapGetters } from "vuex";

export default {
    components: {
    },
    props: {
        stateLoading: {
            type: Boolean,
            default: false,
        },
        optionalParams: {
            type: Object,
        },
        typeReestr: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            suppliersSearch:null,
            typeCancelReqest: null,
            isArchive: false,
            selectedDateForOrder: '',
            newCommentValue: null,
            commentsList: [],
            orderId: null,
            titleLine: null,
            dataFromPage: {},
            dataForModal: {},
            selectOptions: {
                b2b_orders__supplier_company_id: [],
                typesSpend: [{
                    label: 'Выручка',
                    value: 1
                }, {
                    label: 'Прибыль',
                    value: 2
                }],
            },
            selectValues: {
                b2b_orders__supplier_company_id: null,
                b2b_orders__supplier_percent_from: null
            },
            updatedValues: {},
            localLoading: false,
        };
    },
    methods: {
    
        numberFromField(name) {
            const raw = this.updatedValues[name] ?? this.dataForModal[name] ?? 0;
            const num = typeof raw === 'string' ? raw.replace(',', '.').trim() : raw;
            const parsed = parseFloat(num);
            return Number.isFinite(parsed) ? parsed : 0;
        },

        formatMoney(val) {
            return Number.isFinite(val) ? val.toFixed(2) : '';
        },

        /*
         * Доля Официального Партнера с маркетплейса
         * TODO: Наверное бэк должен присылать долю ОП с маркетплейса в заявке. Но пока так.
         * Подгрузка по имени города; при совпадении имён берётся первая запись.
         */
        async loadCityMarketplacePercentByName(cityName) {
            if (!cityName || String(cityName).trim() === '') {
                return
            }
            try {
                const res = await GeneralService.get('/cities', {
                    params: {
                        where: JSON.stringify([{ field: 'cities__name', value: String(cityName).trim() }]),
                        limit: 10
                    }
                })
                const rows = res?.data?.data?.rows || []
                const row = rows[0]
                if (row && row.cities__official_partner_percent_3 != null && row.cities__official_partner_percent_3 !== '') {
                    const cityPartnerPercent = row.cities__official_partner_percent_3
                    this.$set(this.dataForModal, 'b2b_orders__partner_percent', cityPartnerPercent)
                    this.updatedValues.b2b_orders__partner_percent = cityPartnerPercent
                }
            } catch (e) {
            }
        },
        async loadRefererBasePercentFromSettings() {
            try {
                const res = await GeneralService.get('/super/settings')
                const rows = res?.data?.data?.rows || []
                const row = rows.find((r) => r.company_settings_super__setting_key === 'crm_setting_77')
                const v = row?.company_settings_super__setting_value
                if (v !== undefined && v !== null && String(v).trim() !== '') {
                    const n = parseFloat(String(v).replace(',', '.'))
                    if (Number.isFinite(n)) {
                        return n
                    }
                }
            } catch (e) {
            }
            return 0
        },

        baseAmount(fromValue) {
            const proceeds = this.numberFromField('b2b_orders__finance_proceeds');
            const benefit = this.numberFromField('b2b_orders__finance_benefit');
            if (fromValue === 2) return benefit;
            return proceeds; // default выручка
        },

        recalculateFinance() {
            const supplierPercent = this.numberFromField('b2b_orders__supplier_percent');
            const supplierFrom = this.numberFromField('b2b_orders__supplier_percent_from');
            const supplierAmount = this.baseAmount(supplierFrom) * supplierPercent / 100;
            const refererCoefficientRaw = this.dataForModal?.b2b_orders__referer_koef ?? 1;
            const refererCoefficientNum = parseFloat(String(refererCoefficientRaw).replace(',', '.'));
            const refererCoefficient = Number.isFinite(refererCoefficientNum) ? refererCoefficientNum : 1;

            const refererBasePercent = this.numberFromField('b2b_orders__referer_base_percent_super');
            const refererPercent = refererBasePercent * refererCoefficient;

            const partnerPercentRaw = this.numberFromField('b2b_orders__partner_percent');
            const partnerPercent = Number.isFinite(partnerPercentRaw) ? partnerPercentRaw : 0;
            const refererAmount = supplierAmount * refererPercent / 100;
            const partnerAmount = supplierAmount * partnerPercent / 100;
            const serviceCompanyPercent = 100 - refererPercent - partnerPercent;

            this.dataForModal.b2b_orders__supplier_amount = this.formatMoney(supplierAmount);
            this.dataForModal.b2b_orders__referer_percent = this.formatMoney(refererPercent);
            this.dataForModal.b2b_orders__referer_amount = this.formatMoney(refererAmount);
            this.dataForModal.b2b_orders__partner_percent = this.formatMoney(partnerPercent);
            this.dataForModal.b2b_orders__partner_amount = this.formatMoney(partnerAmount);
            this.dataForModal.b2b_orders__service_company_percent = this.formatMoney(serviceCompanyPercent);

            this.updatedValues.b2b_orders__supplier_amount = this.dataForModal.b2b_orders__supplier_amount;
            this.updatedValues.b2b_orders__referer_percent = this.dataForModal.b2b_orders__referer_percent;
            this.updatedValues.b2b_orders__referer_amount = this.dataForModal.b2b_orders__referer_amount;
            this.updatedValues.b2b_orders__partner_percent = this.dataForModal.b2b_orders__partner_percent;
            this.updatedValues.b2b_orders__partner_amount = this.dataForModal.b2b_orders__partner_amount;

            const serviceAmount = supplierAmount - refererAmount - partnerAmount;

            this.dataForModal.b2b_orders__service_amount = this.formatMoney(serviceAmount);
            this.updatedValues.b2b_orders__service_amount = this.dataForModal.b2b_orders__service_amount;
        },

        sendOrder(type) {
            this.localLoading = true
            GeneralService.get(`/b2b-orders/notification/${type}/${this.orderId}`)
                .then(async (data) => {
                    this.$toast.success(data.data.message);
                })
                .catch((e) => {
                    if (e?.response?.data) {
                        this.$toast.error(e?.response.data.message, { duration: 5000 });
                    } else {
                        this.$toast.error("ERROR SAVE", { duration: 5000 });
                    }
                }).finally(() => {
                    this.loadComments()
                    this.localLoading = false

                });
        },
        async onCopy(text) {
            if (!navigator.clipboard) {
                console.error('Буфер обмена недоступен в этом браузере.');
                return;
            }
            try {
                await navigator.clipboard.writeText(text);
                this.$toast.info('Почта скопирована')
            } catch (err) {
                this.$toast.error('Ошибка при копировании текста', { duration: 5000 })
            }
        },
        async loadComments() {
            return GeneralService.get(`/b2b-orders/${this.orderId}/comments`)
                .then((data) => {
                    this.commentsList = data.data.data.rows.sort(
                        (a, b) =>
                            b.is_fixed - a.is_fixed
                    );
                })
                .catch((e) => { });
        },
        delComment(id) {
            GeneralService.delete(`/b2b-orders/${this.orderId}/comments/${id}`)
                .then(async (data) => {
                    this.$toast.success(data.data.message);
                    await this.loadComments();
                })
                .catch((e) => { });
        },
        fixComment(id, fix) {
            GeneralService.edit(`/b2b-orders/${this.orderId}/comments/${id}`, {
                fixed: fix,
            })
                .then(async (data) => {
                    this.$toast.success(data.data.message);
                    await this.loadComments();
                    this.newCommentValue = null;
                })
                .catch((e) => { });
        },
        sendComment() {
            if (this.newCommentValue?.value) {
                GeneralService.editOrCreate(`/b2b-orders/${this.orderId}/comments`, {
                    comment: this.newCommentValue.value,
                })
                    .then(async (data) => {
                        // this.selects.push(data.data.data.rows)
                        this.$toast.success(data.data.message);
                        await this.loadComments();
                        this.newCommentValue = null;
                        this.$refs.commentInput.$el.querySelector("input").value = "";
                    })
                    .catch((e) => { });
            } else {
                this.$toast.error("Напишите комментарий", { duration: 5000 });
            }
        },
        updateValue(data) {
            const financeFields = [
                'b2b_orders__finance_proceeds',
                'b2b_orders__finance_benefit',
                'b2b_orders__supplier_percent',
                'b2b_orders__supplier_percent_from',
                'b2b_orders__supplier_amount',
                'b2b_orders__referer_percent',
                'b2b_orders__referer_amount',
                'b2b_orders__partner_percent',
                'b2b_orders__partner_amount',
                'b2b_orders__service_amount',
            ];

            this.updatedValues[data.name] = data.value;
            if (financeFields.includes(data.name)) {
                this.dataForModal[data.name] = data.value;
            }
            if (this.$refs[data.name]) {
                this.$refs[data.name].classList.remove("input-error");
            }
            // if (data.name !== 'contracts__address') {
            //   this.isUpdatedData = true
            // }
            this.recalculateFinance();
        },
        errorsHandler(errors) {
            Object.keys(errors).forEach((elem, index) => {
                if (this.$refs[elem]) {
                    this.$refs[elem].classList.add("input-error");
                }
            });
        },
        async saveModal(isClose = true) {
            this.localLoading = true;
            const financeFields = [
                'b2b_orders__finance_proceeds',
                'b2b_orders__finance_benefit',
                'b2b_orders__supplier_percent',
                'b2b_orders__supplier_percent_from',
                'b2b_orders__supplier_amount',
                'b2b_orders__referer_percent',
                'b2b_orders__referer_amount',
                'b2b_orders__partner_percent',
                'b2b_orders__partner_amount',
                'b2b_orders__service_amount',
            ];

            const payload = { ...this.updatedValues };
            financeFields.forEach((field) => {
                payload[field] = this.dataForModal[field];
            });

            GeneralService.edit(`/b2b-orders/${this.orderId}`, payload)
                .then(async (data) => {
                    this.updatedValues = {};
                    this.$toast.success(data?.data.message, { duration: 5000 });
                    this.$emit("updateDataTable");
                    if (!isClose) {
                        this.loadData({}, false)
                    } else {
                        this.$modal.hide("superSuppliersModal");
                    }

                })
                .catch((e) => {
                    console.error(e);
                    if (e?.response?.data) {
                        this.$toast.error(e?.response.data.message, { duration: 5000 });
                    } else {
                        this.$toast.error("ERROR SAVE", { duration: 5000 });
                    }
                    this.localLoading = false;
                })
        }
        ,

        async loadData(dataFromPage = {}, isOpenFromPage = true) {
            this.localLoading = true;
            console.log(dataFromPage);

            if (isOpenFromPage) {
                this.orderId = dataFromPage.params.b2b_orders__id;
                this.isArchive = dataFromPage.params.isArchive;
                console.log(dataFromPage);
            }
            /**
             * Присвоение локальных данных по клику в записи таблицы
             */
            return Promise.all([
                this.loadComments(),
                GeneralService.get(`/b2b-orders/select/companies`)
                    .then((data) => {
                        this.selectOptions.b2b_orders__supplier_company_id = data.data.data.map((val) => {
                            return { label: Object.entries(val)[0][1], value: Object.entries(val)[0][0] }
                        })
                    })
                    .catch((e) => {
                        this.$toast.error('Неизвестная ошибка при загрузке компаний', { duration: 5000 })
                    }),
            ])
                .then((data) => {

                    GeneralService.get(`/b2b-orders/${this.orderId}`)
                        .then(async (data) => {
                            this.dataForModal = data.data.data;

                            const ensureDefault = (field, fallback) => {
                                if (this.dataForModal[field] === null || this.dataForModal[field] === undefined || this.dataForModal[field] === '') {
                                    this.dataForModal[field] = fallback;
                                    this.updatedValues[field] = fallback;
                                }
                            };

                            ensureDefault('b2b_orders__supplier_percent_from', 1);
                            ensureDefault('b2b_orders__supplier_percent', 10);

                            const supplierOption = this.selectOptions.b2b_orders__supplier_company_id.find((option) =>
                                this.dataForModal.supplier_company_id == option.value
                            );

                            this.selectValues = {
                                b2b_orders__supplier_company_id: supplierOption,
                                b2b_orders__supplier_percent_from: this.selectOptions.typesSpend.find((option) => this.dataForModal.b2b_orders__supplier_percent_from == option.value),
                            };
                            this.dataForModal.b2b_orders__referer_base_percent_super = await this.loadRefererBasePercentFromSettings()
                            // TODO: Наверное бэк должен присылать долю ОП с маркетплейса в заявке. Но пока так.
                            await this.loadCityMarketplacePercentByName(this.dataForModal.cities__name)
                            this.recalculateFinance();
                            this.localLoading = false;
                            this.$emit("updateDataTable");
                        })
                        .catch((e) => {
                            console.error(e);
                            this.$toast.error("ERROR GET TAB1", { duration: 5000 });
                        })

                });
        },
    },

    mounted() {
        this.orderId = null;
    },
    beforeUnmounted() {
    },
    created() {

    },
    beforeDestroy() { },

    computed: {
        ...mapState("translationModule", ["dataLang"]),
        ...mapState("userSettingModule", ["userSetting"]),
        suppliersSearchOptions(){
            if(this.suppliersSearch){
                return this.selectOptions?.b2b_orders__supplier_company_id?.filter(i=>i.value==this.suppliersSearch)
            }else{
                return this.selectOptions?.b2b_orders__supplier_company_id
            }
        },
    },
};
</script>

<style lang="scss"></style>
